import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import LoopVideo from './assets/hosting.mp4'

class HeroVideo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }
    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            .particles {
                position: absolute;
                width: 100%;
                height: 100%;
            }

            background-size: cover;
            background-repeat: no-repeat;
        `

        const VideoContainer = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            position: relative;
            video {
                position: absolute;
            }            
        `
        const Heading2 = styled.h2`
            font-size: 80px;
            font-family: Teko;
            line-height: 80px;
            color: #fff;
            font-weight: 400;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
                font-size: 20px;
                line-height: 20px;
            }
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            margin-top: 40px;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 35px;
                line-height: 35px;
                margin-top: 60px;
            }
            @media (min-width:768px) and (max-width:1400px) {
                font-size: 40px;
                margin-top: 100px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10;
            @media (min-width:768px) and (max-width:1500px) {                
                margin-top: 100px;
            }
            @media (max-width:767px) {                
                margin-top: 100px;                
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #c1eb18;
            font-weight: 300;
            font-size: 20px;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color:#ffffff;
                position: relative;
                bottom: 2.5px;
            }
        `
        const Span = styled.span`
            color: #ffffff;            
        `

        return (
            <Section id="home">
                <VideoContainer style={{ height: `${this.state.width > 500 ? this.state.height : 550}px` }}>
                    <video autoPlay="autoplay" loop="loop" muted style={{ height: `${this.state.width >= 1024 && this.state.width < 1200 ? "100%" : "auto"}` }}>
                        <source src={LoopVideo} type="video/mp4" />
                    </video>
                    <Container>
                        <Content>
                            <Heading1>
                                Hosting en Colombia – Pereira, Bogotá, Bucaramanga
                            </Heading1>
                            <Separator />
                            <Heading2>
                                Alojamiento Web Confiable, Potente y Rápido
                            </Heading2>
                            <ServiceList>
                                <ServiceListElement>
                                    Dominios GRATIS <Span>•</Span> Certificado SSL GRATIS
                                </ServiceListElement>
                                <ServiceListElement>
                                    Discos SSD en RAID 10 <Span>•</Span> Migración GRATIS
                                </ServiceListElement>
                                <ServiceListElement>
                                    Backups 7 días <Span>•</Span> Garantía de devolución 30 días
                                </ServiceListElement>
                            </ServiceList>
                        </Content>
                    </Container>
                </VideoContainer>
            </Section>
        )
    }
}

export default HeroVideo;